<router-outlet></router-outlet>
@if (project$ | async) {
  <nt-feedback-button></nt-feedback-button>
}
@if (error$ | async) {
}
